import { PaymentType } from "../../../constant/PaymentType";
import { LicenceTypePurchase } from "../../../types/Licences/LicenceTypePurchase";

interface PaymentTypeLabelProps {
  licence: LicenceTypePurchase;
}

const PaymentTypeLabel = ({ licence }: PaymentTypeLabelProps) => {
  return (
    <>
      {licence.paymentType === PaymentType.OneOffPayment ? (
        <span>For {licence.expiryDays} days</span>
      ) : licence.paymentType === PaymentType.RecurringPayment ? (
        <span>Per year</span>
      ) : null}
    </>
  );
};

export default PaymentTypeLabel;
